/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade`)
};

const es_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota`)
};

const de_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const nl_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijfer`)
};

const fr_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const it_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voto`)
};

const pt_br2_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota`)
};

const pt_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota`)
};

const ja_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成績`)
};

const zh_gpa_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成绩`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_grade = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_grade(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_grade", locale)
	if (locale === "en") return en_gpa_grade(inputs)
	if (locale === "es") return es_gpa_grade(inputs)
	if (locale === "de") return de_gpa_grade(inputs)
	if (locale === "nl") return nl_gpa_grade(inputs)
	if (locale === "fr") return fr_gpa_grade(inputs)
	if (locale === "it") return it_gpa_grade(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_grade(inputs)
	if (locale === "pt") return pt_gpa_grade(inputs)
	if (locale === "ja") return ja_gpa_grade(inputs)
	return zh_gpa_grade(inputs)
};